import { useSelector } from "react-redux";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { deleteServiceOrRepair, requestDeletingServiceOrRepair, selectState } from "../serviceAndRepair.slice";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";

const DeleteServiceOrRepairModal = () => {
  const { serviceOrRepairToDelete } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingServiceOrRepair(undefined));
  };

  const doDelete = async () => {
    try {
      if (serviceOrRepairToDelete !== undefined) {
        await dispatch(deleteServiceOrRepair({ resourceId: serviceOrRepairToDelete.resource.resourceId, maintenanceId: serviceOrRepairToDelete.serviceId }));
        toast.success("Uspesno obrisan.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={serviceOrRepairToDelete !== undefined}
      title="Brisanje servisa/popravke"
    >
      <p className="info-msg">
        {serviceOrRepairToDelete && `Da li ste sigurni da želite da obrišete servis/popravku (${serviceOrRepairToDelete.resource.name}, ${FormatDateShort(serviceOrRepairToDelete.serviceDoneAtDate)}, ${FormatNumberWithUnitOrNull(serviceOrRepairToDelete.serviceDoneAtUsageAmount, serviceOrRepairToDelete.resourceUsageUnit.name)})?`}
      </p>
    </Modal>
  );
};

export default DeleteServiceOrRepairModal;
